'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

/**
 * Strip `?theme=` after hydration only. Doing this in an inline <head> script with
 * `history.replaceState(null, ...)` runs before Next's router attaches and can break
 * the app (blank screen) or clear router state.
 */
export function ThemeUrlSync() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const q = searchParams.get('theme');
    if (q !== 'dark' && q !== 'light') return;
    const next = new URLSearchParams(searchParams.toString());
    next.delete('theme');
    const qs = next.toString();
    const nu = `${pathname}${qs ? `?${qs}` : ''}${window.location.hash}`;
    const cur = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (nu !== cur) {
      try {
        window.history.replaceState(window.history.state, '', nu);
      } catch {
        /* ignore */
      }
    }
  }, [pathname, searchParams]);

  return null;
}
